import React from 'react';

const ApiDocsPage = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8">
          API Documentation
        </h1>
        
        <div className="prose dark:prose-invert max-w-none">
          <p className="text-xl text-gray-600 dark:text-gray-300 mb-8">
            Integrate Agent Nexus into your applications with our comprehensive API documentation.
            Our RESTful APIs provide powerful capabilities for automation, analytics, and system integration.
          </p>

          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Getting Started
            </h2>
            <div className="bg-gray-100 dark:bg-gray-800 p-6 rounded-lg">
              <pre className="text-sm text-gray-700 dark:text-gray-300">
                <code>
                  # Install using npm{'\n'}
                  npm install @agent-nexus/sdk{'\n\n'}
                  # Or using yarn{'\n'}
                  yarn add @agent-nexus/sdk
                </code>
              </pre>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Authentication
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Secure your API requests using API keys or OAuth 2.0.
                Learn about our authentication methods and best practices.
              </p>
              <span className="text-gray-500 dark:text-gray-400 mt-4 inline-block text-sm">
                Documentation coming soon
              </span>
            </div>

            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Endpoints
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Explore our API endpoints with detailed request/response examples.
                Find the right endpoints for your integration needs.
              </p>
              <span className="text-gray-500 dark:text-gray-400 mt-4 inline-block text-sm">
                Documentation coming soon
              </span>
            </div>

            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                SDKs & Libraries
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Get started quickly with our official SDKs and client libraries.
                Available for multiple programming languages.
              </p>
              <span className="text-gray-500 dark:text-gray-400 mt-4 inline-block text-sm">
                Documentation coming soon
              </span>
            </div>

            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Webhooks
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Subscribe to real-time events with webhooks.
                Learn how to handle and process webhook notifications.
              </p>
              <span className="text-gray-500 dark:text-gray-400 mt-4 inline-block text-sm">
                Documentation coming soon
              </span>
            </div>
          </div>

          <div className="bg-primary-50 dark:bg-gray-800 p-8 rounded-lg mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              API Features
            </h2>
            <ul className="space-y-4 text-gray-600 dark:text-gray-300">
              <li className="flex items-start">
                <svg className="h-6 w-6 text-primary-600 dark:text-primary-400 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>RESTful API design with JSON responses</span>
              </li>
              <li className="flex items-start">
                <svg className="h-6 w-6 text-primary-600 dark:text-primary-400 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Rate limiting and usage monitoring</span>
              </li>
              <li className="flex items-start">
                <svg className="h-6 w-6 text-primary-600 dark:text-primary-400 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Comprehensive error handling</span>
              </li>
              <li className="flex items-start">
                <svg className="h-6 w-6 text-primary-600 dark:text-primary-400 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>HTTPS encryption for all requests</span>
              </li>
            </ul>
          </div>

          <div className="text-center">
            <a 
              href="/contact" 
              className="inline-block bg-primary-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-primary-700 transition-colors"
            >
              Get API Access
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiDocsPage; 